// Shared motion tokens — one source of truth for the site's animation feel.
export const EASE = [0.16, 1, 0.3, 1];
export const EASE_SILK = [0.25, 0.1, 0.25, 1];

export const SPRING = { type: "spring", stiffness: 220, damping: 20, mass: 0.6 };
export const SPRING_SOFT = { type: "spring", stiffness: 120, damping: 18 };
export const SPRING_MODAL = { type: "spring", stiffness: 300, damping: 28, mass: 0.8 };

export const fadeUp = (delay = 0, y = 28) => ({
  initial: { opacity: 0, y },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.8, delay, ease: EASE },
});
